import { useState, useEffect } from 'react';
import apiFunctions from '../../api';
import { createSearchParams, useNavigate } from 'react-router';
import { failure, unauthorized } from '../../types/api';
import { Errors } from '../../types/errors';
import Config from './components/Config';
import './index.configLookup.css';
import '../../index.css';
import { CircularProgress } from '@mui/material';

const ConfigLookup = () => {
  let [configs, setConfigs] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    let subscribed = true;

    const getConfigs = async () => {
      await apiFunctions.apiPost('Kirby/ConfigDetails/GetAllConfigs').then((data) => {
        if (data === failure) {
          navigate({
            pathname: '/error',
            search: `?${createSearchParams({ errType: Errors.CallFailed })}`,
          });
        } else if (data === unauthorized) {
          navigate({
            pathname: '/error',
            search: `?${createSearchParams({ errType: Errors.Unauthorized })}`,
          });
        }

        setConfigs(data);
        setLoading(false);
      });
    };

    if (subscribed) {
      getConfigs();
    }

    return () => {
      subscribed = false;
    };
  }, [navigate]);

  // function that will get all config information and set state variable
  // if API call fails, will redirect user to error page

  if (loading) {
    return <CircularProgress />;
  }

  return (
    <div>
      <Config configs={configs} />
    </div>
  );
};

export default ConfigLookup;
